import { useEffect, useMemo, useRef } from 'react';

import { IProps } from './types';

/** При дизейбле всех свойств кроме одного, выбирает оставшееся свойство **/
export const useSelectSingleAvailableValue = ({ source, value, onChange, enabled = true }: IProps) => {
  const singleAvailableOption = useMemo(() => {
    const availableOptions = source?.filter(item => !item.disabled) ?? [];

    return availableOptions.length === 1 ? availableOptions[0] : null;
  }, [source]);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    if (!enabled) {
      return;
    }
    if (!singleAvailableOption) {
      return;
    }
    const isSameValue = singleAvailableOption.value === value || String(singleAvailableOption.value) === String(value);
    if (!isSameValue) {
      onChangeRef.current(singleAvailableOption.value);
    }
  }, [enabled, singleAvailableOption, value]);
};
